/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReorderAssignmentRulesRequest
 */
export interface ReorderAssignmentRulesRequest {
    /**
     * 
     */
    rule_ids: Array<string>;
}

/**
 * Check if a given object implements the ReorderAssignmentRulesRequest interface.
 */
export function instanceOfReorderAssignmentRulesRequest(value: object): value is ReorderAssignmentRulesRequest {
    if (!('rule_ids' in value) || value['rule_ids'] === undefined) return false;
    return true;
}

export function ReorderAssignmentRulesRequestFromJSON(json: any): ReorderAssignmentRulesRequest {
    return ReorderAssignmentRulesRequestFromJSONTyped(json, false);
}

export function ReorderAssignmentRulesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReorderAssignmentRulesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'rule_ids': json['rule_ids'],
    };
}

export function ReorderAssignmentRulesRequestToJSON(json: any): ReorderAssignmentRulesRequest {
    return ReorderAssignmentRulesRequestToJSONTyped(json, false);
}

export function ReorderAssignmentRulesRequestToJSONTyped(value?: ReorderAssignmentRulesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rule_ids': value['rule_ids'],
    };
}

